const questionMapping = {
  age: 'HRA-DQ-01',
  genderIdentity: 'HRA-DQ-03',
  diagnoses: 'HRA-MH-44',
  previousAntiObesityMedications: 'HRA-WH-09',
  previousBariatricSurgeries: 'HRA-MH-02',
  whichPreviousBariatricSurgeries: 'HRA-MH-02-a',
  historyOfEatingDisorder: 'HRA-MH-03',
  activeEatingDisorder: 'HRA-MH-03-a',
  workingWithMentalHealthProfessional: 'HRA-MH-03-b',
  biggestMealOfTheDay: 'HRA-EP-03',
  typicalBreakfast: 'HRA-EP-01',
  weeklyRestaurantMeals: 'HRA-EP-05',
  foodAllergiesSensitivities: 'HRA-WH-11-a',
  weeklySugarSweetenedBeverages: 'HRA-EP-02',
  middleOfTheNightEating: 'HRA-EP-04',
  cravings: 'HRA-FC-02',
  excessiveAppetite: 'HRA-FC-03',
  grazing: 'HRA-FC-04',
  triggerForOvereating: 'HRA-FC-01',
  activityLevel: 'HRA-LS-03',
  typeOfActivity: 'HRA-LS-04-a',
  timesPerWeekDoYouWalk: 'HRA-LS-04-a-a',
  minutesPerWeekDoYouWalk: 'HRA-LS-04-a-b',
  timesPerWeekDoYouRun: 'HRA-LS-04-a-c',
  minutesPerWeekDoYouRun: 'HRA-LS-04-a-d',
  timesPerWeekDoYouStrengthTrain: 'HRA-LS-04-a-e',
  minutesPerWeekDoYouStrengthTrain: 'HRA-LS-04-a-f',
  independentWithADLs: 'HRA-LS-01',
  ambulatory: 'HRA-LS-02',
  osaDiagnosis: 'HRA-MH-34',
  osaTreatment: 'HRA-MH-35',
  ohsDiagnosis: 'HRA-MH-36',
  ohsTreatment: 'HRA-MH-37',
  insomnia: 'HRA-MH-38',
  currentLifestyleFactors: 'HRA-LS-08',
  hoursOfSleepPerNight: 'HRA-MH-40',
  snoring: 'HRA-MH-41',
  witnessedApnea: 'HRA-MH-42',
  daytimeSleepiness: 'HRA-MH-43',
  cancer: 'HRA-MH-050',
  cancerTypes: 'HRA-MH-050-a',
  barrettEsophagus: 'HRA-MH-12',
  alcohol: 'HRA-LS-12',
  nicotineTobacco: 'HRA-LS-16',
  recreationalDrugs: 'HRA-LS-17',
  historyOfDrugAbuse: 'HRA-LS-18',
  biologicalMother: 'HRA-WH-14',
  biologicalFather: 'HRA-WH-16',
  biologicalSiblings: 'HRA-WH-18',
  allergies: 'HRA-WH-10-a',
  allergicReaction: 'HRA-WH-10-b',
  foodAllergies: 'HRA-WH-11-a',
  foodAllergicReaction: 'HRA-WH-11-b',
  medications: 'HRA-WH-08',
  sleepMedications: 'HRA-MH-39',
  weightGainEvents: 'HRA-WH-04',
  lowestAdultWeight: 'HRA-WH-01',
  motivationForWeightLoss: 'HRA-WH-05',
  weightLossGoal: 'HRA-WH-06',
  challenges: 'HRA-WH-07',
  occupationContributorsToWeight: 'HRA-LS-08',
  maritalStatus: 'HRA-LS-09',
  children: 'HRA-LS-10',
  howManyChildren: 'HRA-LS-11',
  pregnancyStatus: 'HRA-WH-12',
  contraception: 'HRA-WH-12b',
  pastSurgeries: 'HRA-WH-13-a',
  familyHistoryMother: 'HRA-WH-14',
  familyHistoryMotherAlive: 'HRA-WH-15',
  familyHistoryFather: 'HRA-WH-16',
  familyHistoryFatherAlive: 'HRA-WH-17',
  familyHistorySiblings: 'HRA-WH-18',
  medullaryThyroidCarcinoma: 'HRA-WH-19',
  phq8: 'HRA-MH-17',
  scoff: 'HRA-SC-01',
  bed2: 'HRA-SC-03',
  bed2Frequency: 'HRA-SC-03a',
  BI: 'HRA-BD-01',
  fhqol: 'HRA-FHQOL-01',
};

const questionMappingConsolidated = {
  age: 'HRA-DQ-01',
  genderIdentity: 'HRA-DQ-03',

  // Aggregated diagnoses
  diagnoses: [
    'HRA-MH-01',
    'HRA-MH-COMORBIDITIES',
    'HRA-MH-OTHER-COMORBIDITY',
    'HRA-MH-14-nested-02',
    'HRA-MH-34',
    'HRA-MH-OHS',
    'HRA-MH-MENTAL',
    'HRA-MH-MENTAL-DETAIL',
    'HRA-DM-07',
  ],

  diabetesDiagnosisDate: 'HRA-DM-01',
  diabetesMedicationDifficulty: 'HRA-DM-02',
  diabetesMedicationDifficultyDetail: 'HRA-DM-02-a',
  bloodSugarMonitoring: 'HRA-DM-03',
  cgmDevice: 'HRA-DM-03-a',
  cgmDeviceOther: 'HRA-DM-03-a-1',
  cgmAccountEmail: 'HRA-DM-03-b',
  lowBloodSugarPast30Days: 'HRA-DM-04',
  severeLowBloodSugarPastYear: 'HRA-DM-05',
  diabetesErVisit: 'HRA-DM-06',
  diabetesErVisitDate: 'HRA-DM-06-a',
  diabetesComplications: 'HRA-DM-07',
  diabetesFootWound: 'HRA-DM-08',
  diabetesRoutineExams: 'HRA-DM-09',

  previousBariatricSurgeries: 'HRA-MH-02',
  whichPreviousBariatricSurgeries: 'HRA-MH-02-a',
  historyOfEatingDisorder: 'HRA-MH-03',
  activeEatingDisorder: 'HRA-MH-03-a',

  foodAllergies: 'HRA-FOOD-ALLERGY',
  foodAllergicReaction: 'HRA-FOOD-ALLERGY-DETAIL',

  middleOfTheNightEating: 'HRA-EP-04',
  cravings: 'HRA-EP-CRAVINGS',
  excessiveAppetite: 'HRA-EP-HUNGRY',
  grazing: 'HRA-EP-SNACK',
  triggerForOvereating: 'HRA-EP-EMOTIONAL',

  activityLevel: 'HRA-LS-DAY',
  ambulatory: 'HRA-LS-02a',
  independentWithADLs: 'HRA-LS-01',

  osaDiagnosis: 'HRA-MH-34',
  ohsDiagnosis: 'HRA-MH-OHS',
  snoring: 'HRA-MH-SNORE',
  daytimeSleepiness: 'HRA-STOP-T',

  cancer: 'HRA-MH-050',
  cancerTypes: 'HRA-MH-050-a',
  barrettEsophagus: 'HRA-MH-12',

  alcohol: 'HRA-LS-ALCOHOL',
  recreationalDrugs: 'HRA-LS-DRUGS',
  nicotineTobacco: 'HRA-MH-SMOKE',

  medications: 'HRA-RX-MEDS',
  allergies: 'HRA-RX-ALLERGY',
  allergicReaction: 'HRA-RX-ALLERGY-DETAIL',

  medullaryThyroidCarcinoma: 'HRA-MH-FAMHX-MTC',
  pregnancyStatus: 'HRA-WH-PREGNANCY',

  phq8: ['HRA-PHQ2-01', 'HRA-PHQ2-02'],

  bed2: 'HRA-SC-03',
  bed2Frequency: 'HRA-SC-03a',

  fhqolShortnessOfBreath: 'HRA-FHQOL-01-nested-02',
};
module.exports = { questionMapping, questionMappingConsolidated };
